// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index_wrapper__ugUup","formField":"index_formField__1P4fq","submitBtn":"index_submitBtn__390zB","cancelBtn":"index_cancelBtn__w69Jh"};